import { useCallback, useMemo, useState } from 'react';

export default function usePopup(defaultDuration = 3000) {
  const [message, setMessage] = useState('');
  const [error, setError]     = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [showError, setShowError]     = useState(false);

  const hideAll = useCallback(() => {
    setShowMessage(false);
    setShowError(false);
  }, []);

  const flashSuccess = useCallback((text, ms = defaultDuration) => {
    setMessage(text || '');
    setShowMessage(true);
    setShowError(false);
    if (ms > 0) {
      window.setTimeout(() => setShowMessage(false), ms);
    }
  }, [defaultDuration]);

  const flashError = useCallback((text, ms = defaultDuration) => {
    setError(text || '');
    setShowError(true);
    setShowMessage(false);
    if (ms > 0) {
      window.setTimeout(() => setShowError(false), ms);
    }
  }, [defaultDuration]);

  // kant-en-klare view die je zo in je component JSX kunt neerzetten
  const view = useMemo(() => (
    <>
      {showMessage && <div className="popup-message">{message}</div>}
      {showError   && <div className="popup">{error}</div>}
    </>
  ), [showMessage, message, showError, error]);

  return {
    // markup
    view,
    // API
    flashSuccess,
    flashError,
    hideAll,
    // desgewenst raw state
    message, error, showMessage, showError,
    setMessage, setError, setShowMessage, setShowError,
  };
}
